export const GameLayers = {
  Background: 'Background',
  Characters: 'Characters',
  GamePad: 'GamePad',
};
